module.exports = __webpack_public_path__ + "img/sitem_bg3.9dc728f4.png";